import styled from 'styled-components';

export const NewGoalContainer = styled.div`
  display: grid;
  grid-template-columns: 200px 600px;
  grid-column-gap: 15px;
  padding: 6px;
  align-items: center;
`;
